import services from "../services";
import * as types from "./mutation-type";

export const setShowToast = ({ commit }, payload) => {
  commit(types.SET_SHOW, payload)
}

export const setShowToastConfirm = ({ commit }, payload) => {
  commit(types.SET_SHOW_TOAST_CONFIRM, payload)
}

export const setMessageToast = ({ commit }, payload) => {
  commit(types.SET_MESSAGE, payload)
}

export const setTimerToast = ({ commit }, payload) => {
  commit(types.SET_TIMER, payload)
}

export const setIconToast = ({ commit }, payload) => {
  commit(types.SET_ICON, payload)
}

export const setThemeToast = ({ commit }, payload) => {
  commit(types.SET_THEME, payload)
}

export const setCallbackToast = ({commit}, payload) => {
    commit(types.SET_CALLBACK_TOAST, payload)
}
